import React, { PureComponent, Fragment } from 'react';
import classnames from 'classnames';
import { scaleLinear } from 'd3-scale';
import { max } from 'd3-array';

import data from '~/assets/data/right_race.csv';
import { sortByKey } from '~/core/scripts/utils';
import withSlide from '~/kits/general/scripts/components/withSlide';
import Icon from '~/core/scripts/components/Icon';

const years = ['1979', '1989', '1994', '1999', '2004', '2009', '2014', '2019'];
const ticks = [0, 10, 20, 30, 40, 50, 60];

const participants = { 1979: 9, 1984: 10, 1989: 12, 1994: 12, 1999: 15, 2004: 25, 2009: 27, 2014: 28, 2019: 28 };

import './BarChartRace.styl';

function getMaxValue(data) {
  return max(years, year => {
    return max(data, d => +d[year]);
  });
}

class BarChartRace extends PureComponent {
  state = {
    dataIndex: 0,
    isPlaying: false
  };

  timeout = null;

  componentDidMount() {
    if (this.props.isActive) {
      this.start();
    }
  }

  componentDidUpdate(lastProps) {
    if (this.props.isActive && !lastProps.isActive) {
      this.start();
    } else if (!this.props.isActive) {
      this.stop();
    }
  }

  start() {
    if (this.state.isPlaying) {
      return false;
    }

    const nextDataIndex = this.state.dataIndex === years.length - 1 ? 0 : this.state.dataIndex;
    this.setState({ isPlaying: true, dataIndex: nextDataIndex }, () => this.animate());
  }

  animate() {
    if (!this.state.isPlaying) {
      return false;
    }

    this.timeout = setTimeout(() => this.tick(), 2000);
  }

  tick() {
    const nextIndex = this.state.dataIndex + 1;

    if (nextIndex === years.length) {
      return this.stop();
    }

    this.setState({ dataIndex: nextIndex });
    this.animate();
  }

  stop() {
    clearTimeout(this.timeout);
    this.setState({ isPlaying: false });
  }

  onClick() {
    if (this.state.isPlaying) {
      return this.stop();
    }

    this.start();
  }

  render() {
    const { title, text, yearTexts } = this.props;
    const { dataIndex } = this.state;
    const currentYear = years[dataIndex];
    const currentData = data
      .slice(0)
      .filter(d => d[currentYear] !== 'NA')
      .map(d => ({ value: +d[currentYear], country: d.country }))
      .sort(sortByKey('value'));

    const maxValue = getMaxValue(data);

    // const maxValue = max(currentData, d => d.value);
    const width = scaleLinear().domain([0, ticks[ticks.length - 1]]).range([0, 100]).clamp(true);
    const buttonIconType = this.state.isPlaying ? 'pause' : 'play';

    return (
      <Fragment>
        <div className="barchart-wrapper">
          <div className="barchart-inner-wrapper">
            <div className="barchart-axis">
            {ticks.map((d, i) => (
              <div key={`tick__${i}`} className="barchart-tick">{d}</div>
            ))}
            </div>
            <div className="barchart">
            {currentData.map((d, i) => (
              <div
                className={classnames('bar-container', { 'is-eu': d.country === 'EU' })}
                style={{ transform: `translate(0, ${i * 110}%)`, width: `${width(d.value)}%` }}
                key={d.country}
              >
                <img className="country-flag" src={`images/flags/${d.country.toLowerCase()}.png`} />
                {d.country}
              </div>
            ))}
            </div>
          </div>
          <div className="barchart-title">
            <div className="barchart-year">{currentYear}</div>
            <div className="slide-title">{title}</div>
            <div className="slide-text">{text}</div>            
          </div>
        </div>
        <div className="barchart-controls">
          <button className="barchart-play btn circle" onClick={() => this.onClick()}>
            <Icon type={buttonIconType} />
          </button>
          <div className="slide-share">Staaten in der EU: <strong>{participants[currentYear]}</strong></div>
          {/* <div className="slide-text">{yearTexts[currentYear]}</div> */}
        </div>
      </Fragment>
    );
  }
}

export default withSlide(BarChartRace);
